import React from 'react';
import '../../styles/layout.css';

export default function Timeline({ records }) {
  if (!records || records.length === 0) {
    return <div className="empty">Select an MSN to view ownership history</div>;
  }

  return (
    <>
      {records.map((r, i) => (
        <div className="tli" key={i}>
          <div className="tldot">{i + 1}</div>
          <div className="tlb">
            <div className="tlop">{r.op || 'Unknown'}</div>
            <div className="tldt">{r.from || '?'} → {r.to || 'Present'}</div>
            <div className="tlm">
              {r.reg ? `Reg: ${r.reg} · ` : ''}{r.type || ''}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
